import FileSaver from 'file-saver';
import moment from 'moment';

export const downloadFile = (src: string, imageTitle: string) => {
  const currentTime = moment().toISOString();
  FileSaver.saveAs(`${src}?v=${currentTime}`, imageTitle.replace(/[^a-zA-Z0-9 ]/g, '-'));
};
